import { useContext, useRef, useEffect, useCallback } from 'react';
import ddt from '@wix/da-ddt';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
const logger = ddt.createLogger('comments');
export function useScrollToLatestComment(lastInsertedCommentId) {
    const isMobile = useContext(MobileContext);
    const needsToScroll = useRef(false);
    const lastCommentElement = useRef();
    const previousLastCommentId = useRef(lastInsertedCommentId);
    useEffect(()=>{
        if (!needsToScroll.current && (!lastInsertedCommentId || lastInsertedCommentId === previousLastCommentId.current)) {
            return;
        }
        previousLastCommentId.current = lastInsertedCommentId;
        if (!lastCommentElement.current) {
            needsToScroll.current = true;
            return;
        }
        needsToScroll.current = false;
        logger.log('Scrolling to latest comment');
        scrollIntoViewWithHeader(lastCommentElement.current, isMobile);
    }, [
        lastInsertedCommentId,
        isMobile
    ]);
    const setLastComment = useCallback((element)=>{
        lastCommentElement.current = element;
    }, []);
    return {
        setLastComment
    };
}

//# sourceMappingURL=useScrollToLatestComment.js.map